// removed by extract-text-webpack-plugin
module.exports = {"project":"X2uA26BLunRtIG9mjtI3V","img":"_2WmFSyU8Ns72Jl7FJdqwkR","content":"_2CGuGeE44JccYksK4SMJxg","tags":"_18TyUM3ORM8BJq5r_WcbYZ","name":"qglZmsCwk2jrnvg4T18EP","engName":"AGgHuomr7hPMhzmYM_jBI","chtName":"_5GMn_qBp8Omr3oFQgksGB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project-full-row/ProjectFullRow.css
// module id = 366
// module chunks = 0